export const fakesUrl = '/cp/fakes';
